export const EMPTY_LOT_FILTERS = {
    search: "",
    status: ""
};
